import React from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locale';

import Table from '@flyblack/common/components/Table';
import Typography from '@flyblack/common/components/Typography';

export interface Props {}

const VendorTableHeader: React.FC<Props> = () => {
  const text = translations.pages.vendors.table.header;

  return (
    <Typography is={Table.Header} type="hummingbird" className="uppercase text-opacity-[64%] justify-between font-bold">
      <Table.Data className="pr-1 w-[30%]" header>
        <FormattedMessage id={text.name} />
      </Table.Data>

      <Table.Data className="pr-1 w-[30%]" header>
        <FormattedMessage id={text.contactPersonName} />
      </Table.Data>

      <Table.Data className="pr-1 w-[30%]" header>
        <FormattedMessage id={text.email} />
      </Table.Data>
    </Typography>
  );
};

export default VendorTableHeader;
